const RECENTS_KEY = "pm_nav_recents_v1";
const FAVORITES_KEY = "pm_nav_favorites_v1";

const MAX_RECENTS = 14;
const MAX_FAVORITES = 32;

function bump() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("pm-nav-launcher-update"));
  }
}

function safeParse(json, fallback) {
  try {
    const v = JSON.parse(json);
    return Array.isArray(v) ? v : fallback;
  } catch {
    return fallback;
  }
}

export function getRecents() {
  if (typeof window === "undefined") return [];
  return safeParse(localStorage.getItem(RECENTS_KEY), []);
}

/**
 * @param {string} rawPath
 * @param {string} label
 */
export function addRecent(rawPath, label) {
  if (!rawPath || typeof window === "undefined") return;
  if (!rawPath.startsWith("/home")) return;

  // Normalize current path: remove query params and trailing slash
  const url = new URL(rawPath, window.location.origin);
  let path = url.pathname;
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }

  const prev = getRecents();
  
  // Filter out existing entries for this specific normalized path
  // ALSO: Full de-duplicate check for whole list during this mutation (cleanup old garbage)
  const deduped = prev.filter((r) => {
    if (!r.path) return false;
    // Normalize existing paths for comparison
    const existing = r.path.split('?')[0].replace(/\/$/, "");
    return existing !== path;
  });
  
  const next = [{ 
    path, 
    label: label || path, 
    ts: Date.now() 
  }, ...deduped].slice(0, MAX_RECENTS);

  localStorage.setItem(RECENTS_KEY, JSON.stringify(next));
  bump();
}

export function getFavorites() {
  if (typeof window === "undefined") return [];
  return safeParse(localStorage.getItem(FAVORITES_KEY), []);
}

/**
 * @param {string} path
 * @param {string} label
 */
export function addFavorite(path, label) {
  if (!path) return;
  const favs = getFavorites();
  if (favs.some((f) => f.path === path)) return;
  const next = [...favs, { path, label: label || path }].slice(0, MAX_FAVORITES);
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
  bump();
}

export function removeFavorite(path) {
  const next = getFavorites().filter((f) => f.path !== path);
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
  bump();
}

export function toggleFavorite(path, label) {
  if (getFavorites().some((f) => f.path === path)) {
    removeFavorite(path);
    return false;
  }
  addFavorite(path, label);
  return true;
}

export function isFavoritePath(path) {
  return getFavorites().some((f) => f.path === path);
}
